import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import MissionSection from './components/MissionSection';
import AthenaAdvantageSection from './components/AthenaAdvantageSection';
import WhoWeServeSection from './components/WhoWeServeSection';
import Partners from './components/Partners';
import StatsSection from './components/StatsSection';
import NewFooter from './components/NewFooter';
import UserMigrationTeamsSplash from './components/UserMigrationTeamsSplash';
import ResetPassword from './components/ResetPassword';
import RequestForm from './components/RequestForm';
import ForgotPassword from './components/ForgotPassword';
import ProtectedRoute from './components/ProtectedRoute';
import AthenaDownload from './components/AthenaDownload';
import AdemDownload from './components/AdemDownload';
import NotFound from './components/NotFound';
import './styles.css';

const App: React.FC = () => {
  return (
    <Router>
      <ConditionalHeaderAndFooter>
        <Routes>
          <Route
            path='/'
            element={
              <>
                <HeroSection />
                <MissionSection />
                <AthenaAdvantageSection />
                <WhoWeServeSection />
                <Partners />
                <StatsSection />
              </>
            }
          />
          <Route path='/request-account' element={<RequestForm />} />
          <Route path='/forgot-password' element={<ForgotPassword />} />
          <Route
            path='/user-migration-teams'
            element={<UserMigrationTeamsSplash />}
          />
          <Route
            path='/athena/migrate-account'
            element={
              <ProtectedRoute>
                <ResetPassword />
              </ProtectedRoute>
            }
          />
          <Route path='/athena' element={<AthenaDownload />} />
          <Route path='/adem' element={<AdemDownload />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </ConditionalHeaderAndFooter>
    </Router>
  );
};

const ConditionalHeaderAndFooter: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  // Normalize pathname by removing trailing slash
  const pathname = location.pathname.replace(/\/$/, '') || '/';
  const showHeaderAndFooter = pathname === '/';
  return (
    <>
      {showHeaderAndFooter && <Header />}
      <main>{children}</main>
      {showHeaderAndFooter && <NewFooter />}
    </>
  );
};

export default App;
